const R = 6378137.0;

export const metersToLatLng = (lat: number, lng: number, dX: number, dY: number) => {
  const dLat = dY / R;
  const dLng = dX / (R * Math.cos((Math.PI * lat) / 180));

  const newLat = lat + (dLat * 180) / Math.PI;
  const newLng = lng + (dLng * 180) / Math.PI;

  return [newLat, newLng];
};

export const rotatePoint = (cx: number, cy: number, px: number, py: number, angle: number) => {
  const radians = (Math.PI / 180) * angle;

  const cos = Math.cos(radians);
  const sin = Math.sin(radians);

  const nx = cos * (px - cx) + sin * (py - cy) + cx;
  const ny = cos * (py - cy) - sin * (px - cx) + cy;

  return [nx, -ny];
};
